import { useRegisterMutation } from "@/rtkQuery/features/services/auth/authApi.slice";
import { AuthService } from "@/rtkQuery/features/services/auth/authService";
import type { QuestionnaireSubmissionRequest } from "@/design-system/Templates/QuestionnairesTemplate/questionnaire.types";

export const useQuestionnaireSubmission = () => {
    const service = new AuthService();
    const [triggerRegister, { isLoading, error }] = useRegisterMutation();

    const submitQuestionnaire = async (payload: QuestionnaireSubmissionRequest) => {
        return service.register(triggerRegister, payload, {
            success: "You have successfully registered.",
        });
    };

    return {
        submitQuestionnaire,
        isLoading,
        error,
    };
};
